import Page from "components/Page";
import gageIcon from "assets/gage.svg";
import knowledgeBaseIcon from "assets/knowledge-base.svg";
import React from "react";
import {ActionCard} from "../../components/ActionCard";

function Support() {
  const breadcrumbs = {'Admin': '/', 'Support': '/support'}

  return (
    <Page title="Support"breadcrumbs={breadcrumbs}>
      <div className='grid grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] gap-6'>
        <ActionCard
          imageSrc={gageIcon}
          heading='Gage'
          description='Ask questions and get help from Gage, our AI powered support assistant.'
          buttonText='Chat with Gage'
          onClick={() => {
            if (window?.HubSpotConversations) {
              // Load and open the HubSpot Chat widget
              window.HubSpotConversations.widget.load();
              window.HubSpotConversations.widget.open();

              // Remove widget on close to reset state
              window.HubSpotConversations?.on("widgetClosed", () => {
                window.HubSpotConversations.widget.remove();
              });
            }
          }}
        />

        <ActionCard
          imageSrc={knowledgeBaseIcon}
          heading='Knowledge Base'
          description='Browse our comprehensive knowledge base for articles, guides, and FAQs to help you get the most out of our platform and app.'
          buttonText='View our Knowledge Base'
          onClick={() => window.open("https://www.n-gage.io/knowledge-base", "_blank")}
        />
      </div>

    </Page>
  );
}

export default Support;